import React, { PureComponent } from 'react';
import RenglonDatosAdicionales from './RenglonDatosAdicionales';

class RegistroRenglonModelo extends PureComponent {
    constructor(props) {
        super(props);

        this.mostrarModalCopiarRenglonContable = this.mostrarModalCopiarRenglonContable.bind(this);
        this.funcionLlamadaModalABMModelos = this.funcionLlamadaModalABMModelos.bind(this);
    }

    mostrarModalCopiarRenglonContable(renglon, criterios, mostrarSignoAmbos) {
        this.props.cargarValoresModalCopiarRenglonContable(renglon, criterios, mostrarSignoAmbos);
        this.props.mostrarOcultarModalCopiarRenglonContable("modalCopiarRenglonContable", true);
    }

    funcionLlamadaModalABMModelos(renglon, criterios) {
        this.props.datosEdicionRenglon(renglon, criterios);
        this.props.mostrarOcultarModalAltaEdicionRenglonContable("modalAltaEdicionRenglonContable", true);
    }

    render() {
        const {
            claseUltimoRegistro,
            criterios,
            esPar,
            mostrarSignoAmbos,
            permisoModificacion,
            registro,
            renglon
        } = this.props;

        /* ACTIONS */
        const {
            agregarEliminarRenglonContable,
            mostrarOcultarDatosAdicionalesRenglon,
            mostrarOcultarModalAltaEdicionRenglonContable
        } = this.props;
        
        let estiloPar = esPar ? " seccionGrilla__registro--registroGris" : "";
        let estiloFlechaDesplegado = registro.estaDesplegado ? "seccionRenglonesModelo__renglonModelo__trianguloUp seccionRenglonesModelo__renglonModelo__trianguloUp--activo" : "seccionRenglonesModelo__renglonModelo__trianguloDown";

        return (
            <div>
                <div className={"seccionRenglonesModelo__renglonModelo" + estiloPar}>
                    <div className="seccionRenglonesModelo__renglonModelo__contenedorRegistros seccionRenglonesModelo__contenedorTipoOperacion">
                        <div className="seccionRenglonesModelo__tipoOperacionIndividual">
                            {registro.tipoOperacion}
                        </div>
                    </div>

                    <div className="seccionRenglonesModelo__renglonModelo__contenedorRegistros seccionRenglonesModelo__contenedorNRenglon seccionRenglonesModelo__datoNRenglon">
                        {registro.nroRenglon}
                    </div>

                    <div className="seccionRenglonesModelo__renglonModelo__contenedorRegistros seccionRenglonesModelo__contenedorDescripcion">
                        {registro.descripcion}
                    </div>

                    <div className="seccionRenglonesModelo__renglonModelo__contenedorRegistros seccionRenglonesModelo__contenedorCuentaContable">
                        {registro.cuentaContable}
                    </div>

                    <div className="seccionRenglonesModelo__renglonModelo__contenedorRegistros seccionRenglonesModelo__contenedorTipoMovimiento">
                        {registro.tipoMovimiento}
                    </div>

                    <div className="seccionRenglonesModelo__renglonModelo__contenedorRegistros seccionRenglonesModelo__contenedorCampo">
                        {registro.campo}
                    </div>

                    <div className="seccionRenglonesModelo__renglonModelo__contenedorRegistros seccionRenglonesModelo__contenedorMoneda">
                        {registro.moneda}
                    </div>

                    <div className="seccionRenglonesModelo__renglonModelo__contenedorRegistros seccionRenglonesModelo__contenedorAccion">
                        <div>
                            <div className={"seccionRenglonesModelo__renglonModelo__accionEditar"  + (permisoModificacion ? "" : " seccionRenglonesModelo__renglonModelo__accionEditar--deshabilitado")} onClick={() => permisoModificacion ? this.funcionLlamadaModalABMModelos(renglon, criterios) : null}></div>
                            <div className={"seccionRenglonesModelo__renglonModelo__accionCopiar" + (permisoModificacion ? "" : " seccionRenglonesModelo__renglonModelo__accionCopiar--deshabilitado")} onClick={() => permisoModificacion ? this.mostrarModalCopiarRenglonContable(renglon, criterios, mostrarSignoAmbos) : null}></div>
                            <div className={"seccionRenglonesModelo__renglonModelo__accionEliminar" + (permisoModificacion ? "" : " seccionRenglonesModelo__renglonModelo__accionEliminar--deshabilitado")} onClick={() => permisoModificacion ? agregarEliminarRenglonContable(registro.nroRenglon, false, true) : null}></div>
                        </div>
                    </div>

                    <div className="seccionRenglonesModelo__renglonModelo__contenedorRegistros">
                        <div className={"seccionRenglonesModelo__renglonModelo__trianguloMarginLeft " + estiloFlechaDesplegado} onClick={() => mostrarOcultarDatosAdicionalesRenglon(registro.nroRenglon, !registro.estaDesplegado)}></div>
                    </div>
                </div>

                <RenglonDatosAdicionales
                    centroCosto={registro.centroCosto}
                    claseUltimoRegistro={claseUltimoRegistro}
                    criterios={criterios}
                    estaDesplegado={registro.estaDesplegado}
                    nroRenglon={registro.nroRenglon}
                    signo={registro.signo}
                    tipoApertura={registro.tipoApertura}
                    tipoRenglon={registro.tipoRenglon}
                />
            </div>
        );
    }
}

export default RegistroRenglonModelo;